import { Component, Input } from '@angular/core';

@Component({
  selector: 'cai-registration-password-field',
  templateUrl: './registration-password-field.component.html',
  styleUrls: ['./registration-password-field.component.scss'],
  standalone: false,
})
export class RegistrationPasswordFieldComponent {
  @Input()
  passwordControl: any;

  @Input()
  isCargoWallet: boolean;

  public getPasswordStrength(isUnderline?: boolean): string {
    if (this.passwordControl) {
      const strongRegex =
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!'#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[A-Za-z\d!'#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,99}$/,
        mediumRegex = new RegExp(
          '^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})',
        );
      if (strongRegex.test(this.passwordControl.value)) {
        if (isUnderline) {
          return 'strong';
        }
        return $localize`:@@registration.user.password-strong:strong`;
      }
      if (mediumRegex.test(this.passwordControl.value)) {
        if (isUnderline) {
          return 'moderate';
        }
        return $localize`:@@registration.user.password-moderate:moderate`;
      }
    }
    if (isUnderline) {
      return 'weak';
    }
    return $localize`:@@registration.user.password-weak:weak`;
  }

  hasError(errorName: string) {
    return (
      this.passwordControl.hasError(errorName) &&
      (this.passwordControl.dirty || this.passwordControl.touched)
    );
  }
}
